<ng-template #routesList let-extraClasses="extraClasses">
  <div class="suggested-routes g-large" [ngClass]="extraClasses">
    @for (group of groups(); track group.originLocationCode) {
      <div class="flex flex--column flex--align-start g-small">
        <h3 class="mr-clear font-heading-5 nordic-blue-900-text text-icon-primary font-title-small">
          {{ 'ondMarketing.flightsFrom' | finLocalization: { origin: group.originCityName } }}
        </h3>

        @for (link of group.links; track link.href) {
          <fcom-link
            [href]="link.disabled ? undefined : link.href"
            [disabled]="link.disabled"
            [icon]="{
              position: IconPosition.RIGHT,
              name: link.disabled ? SvgLibraryIcon.CHECKMARK_BUTTON_SELECTED : SvgLibraryIcon.ARROW_RIGHT,
              extraClasses: link.disabled ? 'success-900-text signal-success-notification-border-icon-text' : undefined,
            }"
          >
            {{ link.originCityName }}–{{ link.destinationCityName }}
          </fcom-link>
        }
      </div>
    }
  </div>
</ng-template>

@if (type() === OndCrossLinkingType.CITY_TO_CITY_LANDING) {
  @if (loading()) {
    <fcom-loader class="ms-xxlarge-y" [loaderType]="LoaderTheme.EMBEDDED" data-testid="suggested-routes-loader" />
  } @else if (groups().length) {
    <h1
      class="flex flex--middle g-small mr-small-y font-heading-3 nordic-blue-900-text text-icon-primary font-headline-small"
    >
      <fcom-icon class="icon-xlarge" [name]="SvgLibraryIcon.CONNECTING_FLIGHT" />
      {{ 'ondMarketing.exploreMoreHeading' | finLocalization }}
    </h1>

    <ng-container [ngTemplateOutlet]="routesList" [ngTemplateOutletContext]="{ extraClasses: '' }" />
  }
}

@if (type() === OndCrossLinkingType.CITY_TO_CITY) {
  @if (loading()) {
    <fcom-loader class="ms-small-y" [loaderType]="LoaderTheme.EMBEDDED" data-testid="suggested-routes-loader" />
  } @else if (groups().length) {
    <h2
      class="flex flex--middle g-small mr-small-b font-heading-3 nordic-blue-900-text text-icon-primary font-headline-small"
    >
      <fcom-icon class="icon-xlarge" [name]="SvgLibraryIcon.CONNECTING_FLIGHT" />
      {{ 'ondMarketing.exploreMoreHeading' | finLocalization }}
    </h2>

    <ng-container [ngTemplateOutlet]="routesList" [ngTemplateOutletContext]="{ extraClasses: 'ms-large-b' }" />
  }
}
